import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import Particle from "../Particle";
import Github from "./Github";
import Techstack from "./Techstack";
import Aboutcard from "./AboutCard";
import Live2DAvatar from "./Live2D";
import Toolstack from "./Toolstack";
import myImg from "../../Assets/SoraIcon.png";
import Tilt from "react-parallax-tilt";

function About() {
  return (
    <Container fluid className="about-section">
      <Particle />
      <Container>
        <Row style={{ justifyContent: "center", padding: "10px" }}>
          <Col
            md={8}
            style={{
              justifyContent: "center",
              paddingBottom: "50px",
            }}
          >
            <h1 style={{ fontSize: "2.4em" }} class="about-title">
              colors <span className="gradient-text"> gradually </span> painted into the sky <span className="wave" role="img" aria-labelledby="wave">🌈</span>
            </h1>
            <Aboutcard />
          </Col>
          <Col md={4} className="myAvtar">
     {/*        <Tilt>
              <img src={myImg} className="img-fluid" alt="avatar" />
            </Tilt>

    */}
        <Live2DAvatar/>
          </Col>
        </Row>
     {/*   <h1 className="project-heading">
          Professional <strong className="purple">Skillset </strong>
        </h1>

        <Techstack />

        <h1 className="project-heading">
          <strong className="purple">Tools</strong> I use
        </h1>
        <Toolstack />

          <Github />*/}
      </Container>
    </Container>
  );
}

export default About;
